import { render, staticRenderFns } from "./serviceMerchant.vue?vue&type=template&id=386fe93d&scoped=true"
import script from "./serviceMerchant.vue?vue&type=script&lang=js"
export * from "./serviceMerchant.vue?vue&type=script&lang=js"
import style0 from "./serviceMerchant.vue?vue&type=style&index=0&id=386fe93d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386fe93d",
  null
  
)

export default component.exports